import { RemarketEligibilityStatus } from 'enums';
import { messages } from 'i18n';

export interface SubmissionRemarketingEligibilityConfigProps {
  text: string;
  color: string;
}

const { remarketingEligibility } = messages.submissionWorkspace.marketRequestsWorkspace;

export const submissionRemarketingEligibilityConfig: Record<
  RemarketEligibilityStatus,
  SubmissionRemarketingEligibilityConfigProps
> = {
  [RemarketEligibilityStatus.Eligible]: {
    text: remarketingEligibility.eligible,
    color: 'green.100',
  },
  [RemarketEligibilityStatus.NotEligible]: {
    text: remarketingEligibility.notEligible,
    color: 'error.light',
  },
};

export const getRemarketingEligibilityConfig = (
  status?: RemarketEligibilityStatus,
): SubmissionRemarketingEligibilityConfigProps => {
  if (!status || !submissionRemarketingEligibilityConfig[status]) {
    return {
      text: remarketingEligibility.default,
      color: 'blueGrey.100',
    };
  }
  return submissionRemarketingEligibilityConfig[status];
};
